// Shared numeric-input parser (ticket-later register: `parseNum` was copy-pasted
// into 13 form/editor components — this is the single implementation; every copy
// was byte-identical). Mantine's `NumberInput` (react-number-format) calls onChange
// with the RAW in-progress STRING instead of a parsed number whenever the typed
// value still matches its `trailingZerosPattern` (e.g. "3062.50" while typing
// "3062.500") — so state must accept `number | string` and NOT coerce in onChange (a
// parseFloat there would drop an in-progress "3." on every keystroke). Parsing/
// validity happens only where the value is consumed. Returns null for '' (cleared)
// or a non-finite parse.
export function parseNum(v: number | string): number | null {
  if (v === '') return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}
